import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, isLoading, user, checkAuth, initialized } = useAuth();
  const location = useLocation();
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      if (!hasChecked && requireAuth) {
        await checkAuth();
        setHasChecked(true);
      }
    };

    verifyAuth();
  }, [requireAuth, hasChecked, checkAuth]);

  // Show loading while checking initial auth
  if (!initialized || isLoading) {
    return <LoadingSpinner />;
  }

  // If route requires authentication but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // If route is public (like /auth) but user is already authenticated
  if (!requireAuth && isAuthenticated) {
    // Allow admin users to access sign-in page
    // Only redirect non-admin users away from auth page
    if (user?.role !== 'admin') {
      return <Navigate to="/" replace />;
    }
    // Admin users can stay on the page
  }

  return children;
};

export default ProtectedRoute;